export const isKnownEnumRawValue = <T extends string>(rawValue: unknown, allowedValues: readonly T[]): boolean => {
  const rawText = String(rawValue ?? '').trim();
  return allowedValues.some((value) => value === rawText);
};

export const parseKnownEnumRawValue = <T extends string>(rawValue: unknown, allowedValues: readonly T[], fallback: T): T => {
  const rawText = String(rawValue ?? '').trim();
  return allowedValues.find((value) => value === rawText) ?? fallback;
};

export const isUnsupportedEnumRawValue = <T extends string>(rawValue: unknown, allowedValues: readonly T[]): boolean => {
  const rawText = String(rawValue ?? '').trim();
  if (!rawText) return false;
  return !isKnownEnumRawValue(rawText, allowedValues);
};
